import type { FC } from 'react';
import React from 'react';

import type { InterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { Grid } from '@interstate/components/Grid';
import { StyledBreakdownLabel } from '../../BaseDealActivity.interstate.style';
import InterstateDealSummary from '../../../dealSummary/DealSummary.interstate';
import BreakdownTabsContainer from './BreakdownTabs/BreakdownTabsContainer.interstate';
import { useSelector } from 'react-redux';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import * as baseDealSelectors from '@makemydeal/dr-dash-store/selectors/BaseDealSelectors';
import { Box } from '@interstate/components/Box';

type BreakdownSidebarProps = {
    scopeId: string;
    fullWidth?: boolean;
    isLightMode?: boolean;
    alwaysVisible?: boolean;
};

const getBreakdownContainerStyles = (isLightMode: boolean, fullWidth: boolean) => ({
    ...(isLightMode && {
        [`.chevron-icon,
         .summary-item-expandable-label,
         .summary-item-expandable-value,
         .summary-item-label,
         .summary-item-value,
         .summary-item-detail-label,
         .summary-item-detail-value`]: {
            color: 'inherit !important'
        }
    }),
    borderRadius: '0.625rem',
    boxShadow: (theme: InterstateTheme) => theme.tokens.BaseShadowLg,
    backgroundColor: (theme: InterstateTheme) => (isLightMode ? theme.tokens.BaseColorWhite : '#f4f4f4'),
    ...(fullWidth
        ? { width: '100%' }
        : {
              maxWidth: isLightMode ? '280px' : '360px',
              width: isLightMode ? '280px' : '360px'
          })
});

const Breakdown: FC<BreakdownSidebarProps> = ({ scopeId, fullWidth = false, isLightMode = false, alwaysVisible = false }) => {
    const isBreadownStatusOpen = useSelector(baseDealSelectors.getBreakdownStatus);
    const isDealRecapTabEnabled = useSelector(featureToggleSelectors.useDealRecapEnabled);

    const isBreakDownOpen = alwaysVisible || isBreadownStatusOpen;

    return (
        <>
            {!isDealRecapTabEnabled && isBreakDownOpen ? (
                <Grid
                    xs={5}
                    sx={{
                        ...getBreakdownContainerStyles(isLightMode, fullWidth),
                        ...(!fullWidth && { flex: 1, padding: 0 })
                    }}
                >
                    <StyledBreakdownLabel>Breakdown</StyledBreakdownLabel>
                    <InterstateDealSummary />
                </Grid>
            ) : null}
            {isDealRecapTabEnabled && isBreakDownOpen && (
                <Box sx={getBreakdownContainerStyles(isLightMode, fullWidth)}>
                    <BreakdownTabsContainer scopeId={scopeId} isFullWidth={fullWidth} />
                </Box>
            )}
        </>
    );
};

export default Breakdown;
